import { render } from "./PbShow.vue?vue&type=template&id=3a80fbea"
import script from "./PbShow.vue?vue&type=script&lang=js"
export * from "./PbShow.vue?vue&type=script&lang=js"

import "./PbShow.vue?vue&type=style&index=0&id=3a80fbea&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__